<template>
  <div class="promotions-summary">
    <fieldset class="promotions-summary__fieldset">
      <legend class="promotions-summary__legend"></legend>
      <div class="promotions-summary__line-items">
        <div
          v-for="(promotionSummary, index) in promotionsSummary"
          :key="index"
          :class="[
            'promotions-summary__item',
            { hidden: isPromotionHidden(promotionSummary) },
          ]"
          @click="handleItemClick(!isPromotionChecked(promotionSummary))"
        >
          <input
            :id="'promotion-' + index"
            type="radio"
            name="promotion"
            :value="index"
            :checked="isPromotionChecked(promotionSummary)"
            :disabled="!isPromotionChecked(promotionSummary)"
            class="promotions-summary__input"
          />
          <label
            :for="'promotion-' + index"
            :class="[
              'promotions-summary__label',
              { disabled: !isPromotionChecked(promotionSummary) },
            ]"
          >
            <span
              :class="[
                'promotions-summary__label-text',
                { disabled: !isPromotionChecked(promotionSummary) },
              ]"
            >
              {{ promotionSummary.label }}
            </span>
            <span
              :class="[
                'promotions-summary__label-price',
                { disabled: !isPromotionChecked(promotionSummary) },
              ]"
            >
              ({{ formatPrice(promotionSummary.total) }})
            </span>
          </label>
          <info-icon
            :tooltip="true"
            :description="promotionSummary.description"
          />
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import priceable from '~/mixins/priceable'
import InfoIcon from '~/components/icons/info/Info.vue'

export default {
  name: 'LineItemPromotionSummary',
  components: {
    InfoIcon,
  },
  mixins: [priceable],
  props: {
    promotionsSummary: {
      type: Array,
      required: true,
    },
    promotionApplied: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isPromotionChecked(promotion) {
      if (!this.promotionApplied) {
        return
      }
      return promotion.label === this.promotionApplied?.label
    },
    isPromotionHidden(promotion) {
      if (!this.promotionApplied) {
        return
      }
      const totalPromotionApplied = Math.abs(
        parseFloat(this.promotionApplied?.total)
      )
      const promotionTotal = Math.abs(parseFloat(promotion.total))

      return (
        promotionTotal > totalPromotionApplied || Math.abs(promotionTotal) === 0
      )
    },
    handleItemClick(isDisabled) {
      if (isDisabled) {
        this.displayOptimalPromotionAppliedMessage()
      }
    },
    displayOptimalPromotionAppliedMessage() {
      this.$displayTopMessage(this.$t('cart.promo_already_applied_alert'))
    },
  },
}
</script>

<style lang="scss" scoped>
.promotions-summary {
  line-height: normal;
  padding: 0;
  margin: 0;
  width: 100%;

  &__legend {
    font-size: 17px;
    font-weight: bold;
  }

  &__description {
    font-size: 13px;
    color: #666;
  }

  &__item {
    color: $v4_color_primary;
    display: flex;
    gap: 10px;
    margin-bottom: 8px;

    &.hidden {
      display: none;
    }
  }

  &__input {
    cursor: pointer;
    appearance: none;
    width: 20px;
    height: 20px;
    border: 1.5px solid #e4e4e4;
    background-color: #f0f0f0;
    border-radius: 50%;
    padding: 3px;

    &:checked {
      background-clip: content-box;
      background-color: $v4_color_primary;
      border: 1.5px solid $v4_color_primary;
    }
  }

  &__label {
    font-size: 15px;
    &-text {
      text-transform: none;
    }

    &-price {
      color: $v4_color_primary;
      font-size: 15px;
      transform: translateY(-50%);
      &.disabled {
        color: #a2a2a6;
      }
    }
    &.disabled {
      color: #a2a2a6;
      text-decoration: line-through;
    }
  }
}
</style>
